import ContentLoader from 'react-content-loader';

import useHoustonTheme from '@eduzz/houston-styles/useHoustonTheme';

import { Content } from './styles';

interface IProps {
  loading?: boolean;
}

export const SelectProductItemSkeleton: React.FC<IProps> = ({ loading }) => {
  const theme = useHoustonTheme();

  return (
    <Content>
      <ContentLoader
        backgroundColor={theme.neutralColor.high.medium}
        className='image-bump'
        speed={2}
        foregroundColor={loading ? theme.neutralColor.high.light : theme.neutralColor.high.medium}
      >
        <rect x='0' y='0' rx='0' ry='0' width='64' height='64' />
        <rect x='80' y='0' rx='0' ry='0' width='56' height='18' />
        <rect x='80' y='22' rx='0' ry='0' width='460' height='18' />
        <rect x='80' y='46' rx='0' ry='0' width='72' height='18' />
      </ContentLoader>
    </Content>
  );
};
